module.exports = "/dist/images/en.e4f95bca.png";